import React, { useState, useEffect } from "react";
import { calc_mixture_properties, get_pt_envelope } from "@/services/propsApi";
import { Row, Col, Spin, Space, Divider, Input, message } from "antd";
import MulCharts from "./MulCharts";
import { K0 } from "@/config/const";
import { rebuildFormula } from "@/config/func";
import "./style.less";

const resultMap: any = [
  { name: "P", nameCn: "压力", unit: "Pa" },
  { name: "T", nameCn: "温度", unit: "K" },
  { name: "V", nameCn: "混合物摩尔体积", unit: "m³/mol" },
  { name: "H", nameCn: "混合物摩尔焓", unit: "J/mol" },
  { name: "S", nameCn: "混合物摩尔熵", unit: "J/mol/K" },
  { name: "Cp", nameCn: "混合物摩尔比热容", unit: "J/mol/K" },
  { name: "phase_count", nameCn: "混合物相数", unit: null },
  { name: "MW", nameCn: "混合物分子量", unit: "g/mol" },
  { name: "Z", nameCn: "混合物压缩因子", unit: null },
  { name: "MU", nameCn: "混合物粘度", unit: "Pa*s" },
  { name: "G", nameCn: "混合物摩尔吉布斯自由能", unit: "J/mol" },
];

const Component = (props: any) => {
  const { source, isShow } = props;
  const [cas_list, setCas_list] = useState<any>(null); //cas列表
  const [zs, setZs] = useState<any>(null); //摩尔分数
  const [T, setT] = useState<any>(25); //温度
  const [method, setMethod] = useState<any>("SRK"); //方法
  const [P, setP] = useState<any>(101325); //压力
  const [npoints, setNpoints] = useState<any>(80); //扫描点数
  const [dataSource, setDataSource] = useState<any>(null); //计算结果
  const [PTSource, setPTSource] = useState<any>(null); //包络线图数据
  const [Tmin, setTmin] = useState<any>(25); //最低温度
  const [Tmax, setTmax] = useState<any>(100); //最高温度
  const [propsLoading, setPropsLoading] = useState<any>(false); //物性数据加载中
  const [chartsLoading, setChartsLoading] = useState<any>(false); //图像数据



  useEffect(() => {
    const cList: any = [];
    const zList: any = [];
    source.map((item: any) => {
      cList.push(item.cas_code);
      zList.push(1 / source.length);
    });
    setCas_list(cList);
    setZs(zList);
  }, [source]);

  useEffect(() => {
    if (cas_list) {
      setChartsLoading(true);
      setPropsLoading(true);
      calc_mixture_properties(cas_list, zs, T + K0, P, method).then((res) => {
        setDataSource(res.data.data);
        setPropsLoading(false);
      });

      get_pt_envelope(cas_list, zs, Tmin + K0, Tmax + K0, method, npoints).then((res) => {
        setPTSource(res.data.data);
        setChartsLoading(false);
      });
    }
  }, [cas_list, zs, method]);

  useEffect(() => {
    if (cas_list) {
      setPropsLoading(true);
      calc_mixture_properties(cas_list, zs, T + K0, P, method).then((res) => {
        setDataSource(res.data.data);
        setPropsLoading(false);
      });
    }
  }, [T]);

  useEffect(() => {
    if (cas_list) {
      setChartsLoading(true);
      get_pt_envelope(cas_list, zs, Tmin + K0, Tmax + K0, method, npoints).then((res) => {
        setPTSource(res.data.data);
        setChartsLoading(false);
      });
    }
  }, [Tmin, Tmax]);

  const showReslut = () => {
    if (propsLoading) {
      return (
        <div className="loadingArea">
          <Spin />
        </div>
      );
    } else {
      return (
        <ul className="showMulresult">
          {Object.keys(dataSource).map((key: any, index: number) => {
            if (key === "zs" || key === "P" || key === "T") {
              return "";
            } else {
              return (
                <li key={index}>
                  <div className="mtit">
                    {resultMap.find((item: any) => key === item.name)?.nameCn || key}：
                  </div>
                  <div className="mviv">
                    {typeof dataSource[key] === 'number' ? dataSource[key].toFixed(4) : '--'}
                    <i>{resultMap.find((item: any) => key === item.name)?.unit || ""}</i>
                  </div>
                </li>
              );
            }
          })}
        </ul>
      );
    }
  };

  //绑定快捷键设置温度
  const keySubUpdateT = (e: any) => {
    if (e.key === "Enter") {
      setT(Number(e.target.value));
    }
  };
  //绑定快捷键设置温度上限
  const keySubUpdateTmax = (e: any) => {
    if (e.key === "Enter") {
      setTmax(Number(e.target.value));
    }
  };
  //绑定快捷键设置温度下限
  const keySubUpdateTmin = (e: any) => {
    if (e.key === "Enter") {
      setTmin(Number(e.target.value));
    }
  };

  const changeZS = (e: any) => {
    if (e.key === "Enter") {
      const z: any = []
      let total = 0;
      for (let n = 0; n < source.length; n++) {
        const s: any = document.getElementById(`zs${n}`)
        total += Number(s.value)
        z.push(Number(s.value))
      }
      if (total !== 1) {
        message.error("混合物各组分之和应等于1！");
      } else {
        setZs(z)
      }
    }
  };

  return (
    <Row>
      <Col span={6} style={{ paddingRight: "2rem" }}>
        <div className="t2" style={{ textAlign: "center" }}>
          混合物组分
        </div>
        <Divider
          style={{
            border: "none",
            borderBottom: "1px solid #ccc",
            margin: "1rem 0",
            height: "1px",
          }}
        />
        <ul className="mulZSlist mt2">
          {source
            ? source.map((item: any, index: any) => {
              return (
                <li key={index}>
                  <div className="zstitle">
                    {item.name} ({rebuildFormula(item.formula)})
                  </div>
                  <div className="zsvalue">
                    <input
                      type="input"
                      defaultValue={zs ? zs[index] : ""}
                      id={`zs${index}`}
                      onKeyDown={changeZS}
                    // onKeyDown={(e: any) => {
                    //   if (e.key === "Enter") {
                    //     const tList = [...zs];
                    //     tList[index] = Number(e.target.value);
                    //     setZs(tList);
                    //   }
                    // }}
                    />
                  </div>
                </li>
              );
            })
            : ""}
          <li></li>
        </ul>
      </Col>
      <Col span={18} style={{ borderLeft: "1px solid #ccc", paddingLeft: "2rem" }}>
        <Space>
          <div className="t2">物性计算结果：</div>
          <Input
            prefix="设置温度："
            style={{ width: "15rem" }}
            defaultValue={T}
            onKeyDown={keySubUpdateT}
            suffix={<span className="fieldUnit">℃</span>}
          />
        </Space>
        <Divider
          style={{
            border: "none",
            borderBottom: "1px solid #ccc",
            margin: "1rem 0",
            height: "1px",
          }}
        />
        {dataSource ? showReslut() : ""}
        <div className="mt2">
          <Space>
            <div className="t2">P-T包络线图：</div>
            <Space>
              <Input
                prefix="温度上限："
                style={{ width: "15rem" }}
                defaultValue={Tmin}
                onKeyDown={keySubUpdateTmin}
                suffix={<span className="fieldUnit">℃</span>}
              />
              ~
              <Input
                prefix="温度下限："
                style={{ width: "15rem" }}
                defaultValue={Tmax}
                onKeyDown={keySubUpdateTmax}
                suffix={<span className="fieldUnit">℃</span>}
              />
            </Space>
          </Space>
        </div>
        <Divider
          style={{
            border: "none",
            borderBottom: "1px solid #ccc",
            margin: "1rem 0",
            height: "1px",
          }}
        />
        {isShow ? <MulCharts dataSource={PTSource} loading={chartsLoading} /> : ""}
      </Col>
    </Row>
  );
};

export default Component;
